var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"base-button-container"}},[_c('b-button',_vm._b({attrs:{"id":_vm.id,"name":_vm.name},on:{"click":_vm.$_onclick}},'b-button',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.iconClass)?_c('span',{class:_vm.iconClass}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }